import React, { useState } from "react";
import { Box, Typography, TextField, Button, Grid } from "@mui/material";
import Header from "../../Header/Header";

const TitleStepFour = () => {
    const [formData, setFormData] = useState({
        generalInfo: {
            firstName: "ABC XYZ",
            lastName: "ABC XYZ",
            phoneNumber: "+234 0000 000-0000",
            email: "abc@gmail.com",
        },
        titleServiceNeeds: {
            serviceType: "ABC XYZ",
            transactionType: "ABC XYZ",
        },
        propertyInfo: {
            address: "ABC XYZ",
            city: "ABC XYZ",
            state: "+234 0000 000-0000",
            zipCode: "abc@gmail.com",
        },
        additionalInfo: {
            closingDate: "ABC XYZ",
            knownIssues: "ABC XYZ",
            specialInstructions: "Any special requests or concerns?",
        },
    });

    // Edit mode state for each section instead of individual fields
    const [editSections, setEditSections] = useState({
        generalInfo: false,
        titleServiceNeeds: false,
        propertyInfo: false,
        additionalInfo: false,
    });

    const handleInputChange = (section, field, value) => {
        setFormData((prev) => ({
            ...prev,
            [section]: {
                ...prev[section],
                [field]: value,
            },
        }));
    };

    const toggleEditSection = (section) => {
        setEditSections((prev) => ({
            ...prev,
            [section]: !prev[section],
        }));
    };

    const renderSection = (section, title, fields) => {
        const isEditing = editSections[section];

        return (
            <Box sx={{ mb: 2 }}>
                <Typography variant="h6" sx={{ mb: 3 }}>
                    {title}
                </Typography>
                <div className="tw-bg-[#F1F1F1] p-3 tw-rounded-lg tw-flex tw-flex-col tw-gap-2">
                    {Object.entries(fields).map(([fieldName, label]) => (
                        <Box key={fieldName} sx={{ mb: 0 }}>
                            <Box
                                sx={{
                                    // p: 2,
                                    bgcolor: "background.paper",
                                    borderColor: "divider",
                                    // borderRadius: 1,
                                    // minHeight: "40px",
                                    display: "flex",
                                    textWrap: "nowrap",
                                    alignItems: "center",
                                    color: "#666666",
                                }}
                            >
                                {isEditing ? (
                                    <>
                                        <Typography
                                            sx={{ fontSize: "12px" }}
                                            className="tw-h-full px-2 py-1 tw-text-wrap tw-w-full tw-border-1 tw-border-white tw-font-[600]"
                                        >
                                            {label}
                                        </Typography>
                                        <TextField
                                            fullWidth
                                            variant="standard"
                                            sx={{
                                                "& .MuiInputBase-input": {
                                                    fontSize: "12px",
                                                },
                                            }}
                                            InputProps={{ disableUnderline: false }}
                                            className="px-2"
                                            value={formData[section][fieldName]}
                                            onChange={(e) => handleInputChange(section, fieldName, e.target.value)}
                                        />
                                    </>
                                ) : (
                                    <>
                                        <Typography
                                            sx={{ fontSize: "12px" }}
                                            className="tw-h-full px-2 tw-text-wrap tw-w-full  py-1 tw-border-1 tw-border-white tw-font-[600]"
                                        >
                                            {label}
                                        </Typography>
                                        <Typography
                                            sx={{ fontSize: "12px" }}
                                            className="tw-w-full tw-border-b-1 tw-h-full px-2 py-1  tw-border-white"
                                        >
                                            {formData[section][fieldName]}
                                        </Typography>
                                    </>
                                )}
                            </Box>
                        </Box>
                    ))}
                    <Typography
                        onClick={() => toggleEditSection(section)}
                        color={"primary"}
                        sx={{ mt: 1, fontSize: "12px", bgcolor: "white", display: "flex", justifyContent: "center" }}
                        className="tw-w-full tw-h-full px-2 py-1 tw-cursor-pointer"
                    >
                        {isEditing ? "Save" : "Edit"}
                    </Typography>
                </div>
                {/* Edit button at bottom of section */}
                {/* <Box sx={{ display: "flex", justifyContent: "flex-end", mt: 2 }}></Box> */}
            </Box>
        );
    };

    return (
        <div component="form" className="tw-h-screen  tw-w-full tw-flex tw-justify-center tw-pt-[70px]" sx={{ maxWidth: 800, mx: "auto", p: 4 }}>
            {/* Header Section */}
            <Header title="Apply For Title" />
            <div className="tw-w-[70%]">
                <Box sx={{ mb: 4 }}>
                    <Typography variant="h5" sx={{ fontWeight: 600, mb: 1 }}>
                        Almost There! Review Your Details!
                    </Typography>
                    <Typography variant="body1" color="text.secondary" sx={{ mb: 0.5 }} className="tw-font-[600]">
                        Double-check your information to ensure a smooth title service experience.
                    </Typography>
                    <Typography variant="body2" color="text.secondary">
                        You’re one step away from securing expert title services. Please review all the information below carefully. Accuracy at this
                        stage helps us provide the most efficient and effective service possible.{" "}
                    </Typography>
                </Box>

                <Grid container spacing={4}>
                    {/* Left Column */}
                    <Grid item xs={12} md={6}>
                        {renderSection("generalInfo", "General Information", {
                            firstName: "First name",
                            lastName: "Last name",
                            phoneNumber: "Phone number",
                            email: "Email Address",
                        })}

                        {renderSection("titleServiceNeeds", "Title Service Needs", {
                            serviceType: "Service Type",
                            transactionType: "Transaction Type",
                        })}
                    </Grid>

                    {/* Right Column */}
                    <Grid item xs={12} md={6}>
                        {renderSection("propertyInfo", "Property Information", {
                            address: "Property Address",
                            city: "City",
                            state: "State",
                            zipCode: "ZIP Code",
                        })}

                        {renderSection("additionalInfo", "Additional Information", {
                            closingDate: "Closing Date",
                            knownIssues: "Known Property Issues (Are there any known issues that could affect the title?)",
                            specialInstructions: "Special Instructions",
                        })}
                    </Grid>
                </Grid>

                {/* Submit Button */}
                <Box sx={{ mt: 4 }}>
                    <Button variant="contained" fullWidth className="tw-bg-primary hover:tw-bg-primary_hover ">
                        Submit & Secure My Title Services
                    </Button>
                </Box>
            </div>
        </div>
    );
};

export default TitleStepFour;
